import { AppContextProvider } from './hooks/useAppContext'
import { CenterScreen } from '@ztechapps/webui.util'
import type { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { ApolloProvider } from '@apollo/client'
import React, { useState } from 'react'
import { setupApolloClient } from './config/graphql'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { LoadingLayout, PageLayoutNotFound } from '@ztechapps/webui.page'
import LoadingPage from './view/account/loading/LoadingPage'
import { routesDef } from './config/routes'
import LoginSuccess from './view/account/login-success'
import LoginFailed from './view/account/login-failed'
import JoinPage from './view/account/join'
import Login from './view/account/login'
import { ChangePassword } from './view/account/change-password'
import { PrivateLayout } from './components/PrivateLayout'
import { DashboardPage } from './view/dashboard'
import { CustomerPage } from './view/customer'
import { ProjectPage } from './view/project'
import { ReportsPage } from './view/reports'
import { InvoiceListPage } from './view/invoice/list'

export function App() {
  const [apolloClient, setApolloClient] = useState<ApolloClient<NormalizedCacheObject>>(
    null as unknown as ApolloClient<NormalizedCacheObject>
  )

  React.useEffect(() => {
    const iife = async () => {
      const localApolloClient = setupApolloClient()

      setApolloClient(localApolloClient)
    }
    iife()
  }, [])

  if (!apolloClient) return <CenterScreen>Loading....</CenterScreen>

  return (
    <BrowserRouter>
      <ApolloProvider client={apolloClient}>
        <AppContextProvider>
          <Routes>
            <Route index element={<LoadingPage />} />
            <Route path={routesDef.AuthSuccessPage.path} element={<LoginSuccess />} />
            <Route path={routesDef.AuthFailedPage.path} element={<LoginFailed />} />
            <Route path={routesDef.JoinPage.path} element={<JoinPage />} />
            <Route path={routesDef.LoginPage.path} element={<Login />} />
            <Route path={routesDef.ChangePasswordPage.path} element={<ChangePassword />} />

            <Route
              path={'/app'}
              element={
                <LoadingLayout>
                  <PrivateLayout />
                </LoadingLayout>
              }
            >
              <Route index path={routesDef.OverviewPage.path} element={<DashboardPage />} />
              <Route index path={routesDef.InvoicesPage.path} element={<InvoiceListPage />} />
              <Route index path={routesDef.CustomersPage.path} element={<CustomerPage />} />
              <Route index path={routesDef.ProjectsPage.path} element={<ProjectPage />} />
              <Route index path={routesDef.ReportPage.path} element={<ReportsPage />} />
            </Route>

            <Route path="*" element={<PageLayoutNotFound />} />
          </Routes>
        </AppContextProvider>
      </ApolloProvider>
    </BrowserRouter>
  )
}

export default App
